import React from 'react';
import Button from '../components/Button';

import Success from '../images/icons/success.svg';

import Api from '../Api';

export default class BrandSuggestion extends React.Component {
  constructor(props) {
    super(props);

    this.success = this.success.bind(this);
    this.submit = this.submit.bind(this);

    this.state = {
      success: false,
      error: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  success() {
    return (
      <div className="apply-component page-flyout success">
        <div className="image-wrapper"><img role="presentation" src={Success} /></div>
        <h2>Thank You!</h2>
        <p className="note">We will get in touch with this maker and let you know!</p>
      </div>
    );
  }

  submit() {
    let payload = Api.Utils.getFormValues(
      this,
      [
        'company_name',
        'url',
        'note'
      ]
    );

    return Api.brandLead(payload).then(
      () => {
        this.setState({success: true});
      }
    );
  }

  render() {
    if (this.state.success) {
      return this.success();
    }

    return (
      <div className="apply-component page-flyout">
        <h2>Maker Suggestion Box</h2>
        <p className="note">Let us know about a maker or items you love.</p>
        <div className="input"><input type="text" ref="company_name" placeholder="Maker's Name" /></div>
        <div className="input"><input type="text" ref="url" placeholder="Maker's Website" /></div>
        <div className="input note-input">
          <label htmlFor="note">Note</label>
          <textarea name="note" ref="note" />
        </div>
        <div><Button onClick={this.submit}>Submit</Button></div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/BrandSuggestion.js
 **/